var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import Trigger from "react-foundation-apps/src/trigger";
import Translate from "react-translate-component";
import { getWalletName } from "branding";
import counterpart from "counterpart";
import { Modal, Button } from "bitshares-ui-style-guide";

var BrowserSupportModal = function (_React$Component) {
    _inherits(BrowserSupportModal, _React$Component);

    function BrowserSupportModal() {
        _classCallCheck(this, BrowserSupportModal);

        return _possibleConstructorReturn(this, (BrowserSupportModal.__proto__ || Object.getPrototypeOf(BrowserSupportModal)).apply(this, arguments));
    }

    _createClass(BrowserSupportModal, [{
        key: "_openLink",
        value: function _openLink() {
            var newWnd = window.open("https://www.google.com/chrome/browser/desktop/", "_blank");
            newWnd.opener = null;
        }
    }, {
        key: "render",
        value: function render() {
            return React.createElement(
                Modal,
                {
                    visible: this.props.visible,
                    onCancel: this.props.hideModal,
                    title: counterpart.translate("app_init.browser"),
                    footer: [React.createElement(
                        Button,
                        {
                            key: "submit",
                            type: "primary",
                            onClick: this.props.hideModal
                        },
                        counterpart.translate("app_init.understand")
                    )]
                },
                React.createElement(
                    "div",
                    { className: "grid-block vertical no-overflow" },
                    React.createElement(Translate, {
                        component: "p",
                        content: "app_init.browser_text",
                        wallet_name: getWalletName()
                    }),
                    React.createElement("br", null),
                    React.createElement(
                        "p",
                        null,
                        React.createElement(
                            "a",
                            { className: "external-link", onClick: this._openLink },
                            "Google Chrome"
                        )
                    )
                )
            );
        }
    }]);

    return BrowserSupportModal;
}(React.Component);

export default BrowserSupportModal;